import styled, { css } from 'styled-components';

import {
  LANDING_BREAKPOINT,
  LARGE_SCREEN_BREAKPOINT,
} from '@utils/theme/breakPoint';
import AirportSearch from '@components/views/flight/listing/SearchBar/AirportSearch/SearchBarAirportSearch';
import SearchBarFlightGuestBox from '@components/ui/guest-box/guest-box-flight/SearchBarFlightGuestBox';

export const BOOKER_SIZE = '570px';
export const BookerContainer = styled.div<{
  hasError: boolean;
  bottom: number;
}>`
  margin-bottom: ${({ bottom }) => `${bottom}px`};
  width: 100%;
  opacity: 0.99;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  box-shadow: 0 20px 40px 0 rgba(58, 58, 58, 0.2);
  @media (min-width: ${LARGE_SCREEN_BREAKPOINT}) {
    width: ${BOOKER_SIZE};
    border-radius: 8px;
    overflow: hidden;
  }

  @media (max-width: ${LANDING_BREAKPOINT}) {
    ${({ hasError }) =>
      hasError &&
      css`
        position: absolute;
        top: 223px;
        width: 100%;
      `}
  }
`;

export const HomePageBookerContainer = styled.div<{ bottom?: number }>`
  position: relative;
  width: 100%;
  margin-bottom: auto;

  @media (min-width: ${LANDING_BREAKPOINT}) {
    max-width: fit-content;
    margin-bottom: ${({ bottom }) => (bottom ? `${bottom}px` : '0')};
  }
`;

export const TabsContainer = styled.div<{ hasCyprus?: boolean }>`
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    ${({ hasCyprus }) =>
      hasCyprus
        ? css`
            &&& div {
              display: grid;
              grid-template-columns: 100px 1fr 100px 100px 100px;
            }
          `
        : ''}
  }
`;
export const WhereToGoSearchContainer = styled.div`
  .react-tiny-popover-container {
    width: 570px !important;
    top: -10px !important;
    border-radius: 0 0 8px 8px !important;
  }
`;
export const BookerSearchBarDateRangeInputWrapper = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
  min-height: 77.99px;
  background: ${({ theme }) => theme.palette.white};
  padding: 0 15px;
  @media (max-width: ${LANDING_BREAKPOINT}) and (min-width: ${LARGE_SCREEN_BREAKPOINT}) {
    padding: 0;
  }
  @media (min-width: ${LANDING_BREAKPOINT}) {
    padding: 0;
    border-top: unset;

    .react-tiny-popover-container {
      width: 570px !important;
      top: -20px !important;
    }
  }
`;

export const RadioGroupcontainer = styled.div<{ isFlightTicketPage?: boolean }>`
  display: flex;
  padding: ${({ isFlightTicketPage }) =>
    isFlightTicketPage ? '0px 20px 20px 20px;' : '20px;'};
`;

export const AirportSearchWrapper = styled.div<{ borderRadius?: string }>`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.palette.white};
  border-radius: ${({ borderRadius }) => borderRadius || '8px 8px 0 0'};
  overflow: hidden;
`;

export const IconWrapper = styled.div`
  width: 42px;
  height: 42px;
  background: ${({ theme }) => theme.palette.lynxWhite};
  border-radius: 50%;
  padding: 10px;
  border: solid 1px rgba(41, 42, 44, 0.15);
  margin-right: 15px;
`;

export const PopoverContainerMixin = css`
  width: 100%;
  .react-tiny-popover-container {
    width: 570px !important;
    top: -10px !important;
  }
`;

export const ResponsiveGuestListingContainer = styled.div`
  background: ${({ theme }) => theme.palette.white};
  padding: 0 15px;
`;

export const StyledAirportSearch = styled(AirportSearch)<{
  borderRadius?: string;
}>`
  ${PopoverContainerMixin}
`;

export const StyledBookerFlightGuestBox = styled(SearchBarFlightGuestBox)<{
  borderRadius?: string;
}>`
  ${PopoverContainerMixin}
  .react-tiny-popover-container {
    @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
      ${({ isBookerSearch }) =>
        isBookerSearch
          ? css`
              position: relative !important;
              transform: unset !important;
              top: unset !important;
              box-shadow: unset !important;
            `
          : ''}
    }
  }
`;
export const BookerSearchBarDateRangeHotelInputWrapper = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.palette.white};
  padding: 0 15px;
  @media (max-width: ${LANDING_BREAKPOINT}) and (min-width: ${LARGE_SCREEN_BREAKPOINT}) {
    padding: 0;
  }
  @media (min-width: ${LANDING_BREAKPOINT}) {
    padding: 0;
    border-top: unset;

    .react-tiny-popover-container {
      width: 570px !important;
      top: -10px !important;
    }
  }
`;
